import axios from "axios";

export const submitToCrm = async ({ $form, formDataObj }) => {
    const formMethod = $form.attr("method"); // Form method
    const formRedirect = $form.attr("data-redirect"); // Form redirect location
    const $submit = $("[type=submit]", $form); // Submit button of form
    const buttonText = $submit.val(); // Original button text
    const buttonWaitingText = $submit.attr("data-wait"); // Waiting button text value

    try {
        $submit.prop("disabled", true);
        $submit.val(buttonWaitingText);

        const formId = $form.attr("id");
        let url;
        switch (formId) {
            case "wf-form-Book-Consultation":
                url = "https://hook.eu1.make.com/xwe7lmg3hg569f9d7nw8kvoqcqjgi2qw";
                break;
            case "newsletter-form":
                url = "https://hook.eu1.make.com/xq2dcvw04sf2uaj3xdhxgcpkytbqp2gg";
                break;
        }

        await axios({
            method: formMethod,
            url: url,
            data: formDataObj,
        });

        // If form redirect setting set, then use this and prevent any other actions
        if (formRedirect) {
            window.location = `${formRedirect}?submissionId=${formDataObj.submissionId}`;
            return;
        } else {
            $form
                .hide() // optional hiding of form
                .siblings(".w-form-done")
                .show() // Show success
                .siblings(".w-form-fail")
                .hide(); // Hide failure
        }
    } catch (error) {
        $form
            .siblings(".w-form-done")
            .hide() // Hide success
            .siblings(".w-form-fail")
            .show(); // show failure

        $submit.val(buttonText);
        $submit.prop("disabled", false);
    }
};
